import type { Assessment } from "../types/assessment.js";
import type { ActingParty } from "../types/involvement.js";

/**
 * Whether the party is an assessment's owner: the user who started it, acting
 * for the organisation it was started for. Like a user's involvement
 * (`isInvolvementHeldBy`), it is theirs only in that capacity, so work begun
 * for one organisation is never carried on, read as its owner or submitted
 * while acting for another.
 *
 * A guest acts for no organisation and is never a party here: their own
 * assessment is theirs through the link that asked them.
 *
 * Server queries that select an owner's work restate this in SQL; change
 * them with it.
 */
export const isAssessmentOwner = ({
  assessment,
  party,
}: {
  assessment: Pick<Assessment, "ownerUserId" | "organisationId">;
  party: Pick<ActingParty, "userId" | "organisationId">;
}): boolean =>
  assessment.ownerUserId === party.userId &&
  assessment.organisationId === party.organisationId;
